import React from "react";
import { Select } from "../../form/select/index";
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { Button } from "../../button/index";
import { FaBars, FaTrashAlt, FaCopy } from "react-icons/fa";
import InputMask from "react-input-mask";
import { InputBox } from "../../form/input.box/index";
import { Tooltip } from "../../tooltip/index";
import { Checkbox } from "../../form/checkbox";
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
const Days = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" },
];
const DragHandle = SortableHandle(() => {
    return (React.createElement(InputBox, { className: "no-round width40 cursor-move flex-center" },
        React.createElement("p", { className: "big font-bold" },
            React.createElement(FaBars, null))));
});
const SortableItem = SortableElement((props) => {
    const { itemIndex, itemsLength, change, copy, remove, allowNone } = props;
    const h = props.item;
    return (React.createElement("div", { key: itemIndex, className: "flex-line", style: { alignItems: "flex-end" } },
        React.createElement(DragHandle, null),
        React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(Select, { className: "no-round", options: Days, style: { width: "120px" }, value: h.day, onChange: (e) => change(itemIndex, "day", e.target.value), required: true })),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputMask, { mask: "99:99", value: h.open, onChange: (e) => change(itemIndex, "open", e.target.value), disabled: h.h24 }, (inputProps) => React.createElement(Input, Object.assign({ type: "text", className: "no-round", style: { width: "100px" }, placeholder: "00:00" }, inputProps, { disabled: h.h24 })))),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputMask, { mask: "99:99", value: h.close, onChange: (e) => change(itemIndex, "close", e.target.value), disabled: h.h24 }, (inputProps) => React.createElement(Input, Object.assign({ type: "text", className: "no-round", style: { width: "100px" }, placeholder: "00:00" }, inputProps, { disabled: h.h24 })))),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputBox, { className: "no-round flex-center width75" },
                    React.createElement(Checkbox, { id: `${itemIndex}-24-hours-checkbox`, checked: h.h24, onChange: (e) => change(itemIndex, "h24", e.target.checked) })))),
        (allowNone || itemsLength !== 1) &&
            React.createElement(Tooltip, { text: "Delete", width: 65, position: "top", disable: itemIndex !== 0 },
                React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => remove(itemIndex) },
                    React.createElement(FaTrashAlt, null))),
        React.createElement(Tooltip, { text: "Copy", width: 65, position: "top", disable: itemIndex !== 0 },
            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => copy(itemIndex) },
                React.createElement(FaCopy, null)))));
});
const SortableItemContainer = SortableContainer((props) => {
    return (React.createElement("div", null, props.items.map((item, i) => (React.createElement(SortableItem, { key: `item-${i}`, index: i, item: item, itemIndex: i, itemsLength: props.items.length, change: props.change, remove: props.remove, copy: props.copy, allowNone: props.allowNone })))));
});
export class FieldOpeningHours extends React.Component {
    constructor() {
        super(...arguments);
        this.add = () => {
            const hours = [...this.props.hours];
            hours.push({
                day: "Monday",
                open: "09:00",
                close: "21:00",
                h24: false,
            });
            this.props.onChange(hours);
        };
        this.copy = (i) => {
            const hours = [...this.props.hours];
            const hour = { ...hours[i] };
            hours.push(hour);
            this.props.onChange(hours);
        };
        this.remove = (i) => {
            const hours = ([...this.props.hours]);
            hours.splice(i, 1);
            this.props.onChange(hours);
        };
        this.change = (i, key, value) => {
            const hours = [...this.props.hours];
            hours[i][key] = value;
            this.props.onChange(hours);
        };
        this.onSortEnd = ({ oldIndex, newIndex }) => {
            const { onChange, hours } = this.props;
            onChange(arrayMove(hours, oldIndex, newIndex));
        };
    }
    render() {
        const { hours, allowNone } = this.props;
        if (hours.length === 0) {
            return (React.createElement(Button, { color: "primary-inverse", size: "xs", type: "button", onClick: this.add }, "Add Time Slot"));
        }
        return (React.createElement("div", null,
            React.createElement(Button, { type: "button", size: "xs", color: "primary-inverse", className: "m-b-3", onClick: this.add }, "Add Time Slot"),
            React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                React.createElement("div", { style: { width: "40px", minWidth: "40px" } }),
                React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                    React.createElement(FormGroup, { style: { width: "120px" }, className: "m-b-0", title: "Day", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "100px" }, className: "m-b-0", title: "Open", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "100px" }, className: "m-b-0", title: "Close", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "75px" }, className: "m-b-0", title: "24 Hour", small_title: true, no_border: true }))),
            React.createElement(SortableItemContainer, { helperClass: "zindex-100 bsl-2", pressDelay: 50, useDragHandle: true, items: hours, change: this.change, copy: this.copy, remove: this.remove, onSortEnd: this.onSortEnd, allowNone: allowNone || false })));
    }
}
//# sourceMappingURL=index.js.map